export const FETCH_PERMISSION_REQUEST = "FETCH_PERMISSION_REQUEST";
export const FETCH_PERMISSION_SUCCESS = "FETCH_PERMISSION_SUCCESS";
export const FETCH_PERMISSION_FAIL = "FETCH_PERMISSION_FAIL";

export const CREATE_PERMISSION_REQUEST = "CREATE_PERMISSION_REQUEST";
export const CREATE_PERMISSION_SUCCESS = "CREATE_PERMISSION_SUCCESS";
export const CREATE_PERMISSION_FAIL = "CREATE_PERMISSION_FAIL";

export const UPDATE_PERMISSION_REQUEST = "UPDATE_PERMISSION_REQUEST";
export const UPDATE_PERMISSION_SUCCESS = "UPDATE_PERMISSION_SUCCESS";
export const UPDATE_PERMISSION_FAIL = "UPDATE_PERMISSION_FAIL";

export const SHOW_PERMISSION_REQUEST = "SHOW_PERMISSION_REQUEST";
export const SHOW_PERMISSION_SUCCESS = "SHOW_PERMISSION_SUCCESS";
export const SHOW_PERMISSION_FAIL = "SHOW_PERMISSION_FAIL";
